import { combineReducers } from 'redux';

// Reducers
import adTest from './adTest';
import amp from './amp';
import article from './article';
import front from './front';
import layout from './layout';
import liveBlog from './liveBlog';
import localnews from './localnews';
import marquee from './marquee';
import menu from './menu';
import navbar from './navbar';
import recommended from './recommended';
import router from './router';
import shared from './shared';
import slideshow from './slideshow';
import tve from './tve';
import video from './video';
import waffle from './waffle';

export default combineReducers({
  adTest,
  amp,
  article,
  front,
  layout,
  liveBlog,
  localnews,
  marquee,
  menu,
  navbar,
  recommended,
  router,
  shared,
  slideshow,
  tve,
  video,
  waffle,
});
